import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FaShareAlt } from "react-icons/fa";  // Ya lo tienes importado
import { CarritoContext } from '../context/CarritoContext';
import Swal from 'sweetalert2';
import clienteAxios from '../helpers/axios.helper';

function DetalleProductoServicio() {
  const navigate = useNavigate();
  const { codigo } = useParams(); 
  const [cantidad, setCantidad] = useState(1);
  const { agregarProductoAlCarrito, comprarDirectamente } = useContext(CarritoContext);
  const location = useLocation();
  const [item, setItem] = useState({});
  const [producto,setProducto] = useState(location.state?.producto || null);
  const [servicio,setServicio] = useState(location.state?.servicio || null);
  const [formData, setFormData] = useState({
    email: '',
    mensaje: ''
  });

  const [enviando, setEnviando] = useState(false);  // Estado para manejar la carga durante el envío
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar la carga
  // Manejo de cambios en los campos del formulario
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  
  // Función para manejar la compra directa
  const handleComprar = (item) => {
    const productoConCantidad = {
      ...item,        
      cantidad: cantidad,
    };
    comprarDirectamente(productoConCantidad);
    navigate('/carrito');
  };
  
  // Redirige a la página de marcas
  const handleRedirectMarca = () => {
    navigate('/marcas');
  };
  
  // Función para agregar al carrito
  const handleAgregarAlCarrito = (item) => {
    const productoConCantidad = {
      ...item,        
      cantidad: cantidad,
    };
    agregarProductoAlCarrito(productoConCantidad);
  
    // SweetAlert notificando que el producto se agregó al carrito
    Swal.fire({
      icon: 'success',
      title: '¡Producto agregado al carrito!',
      text: `${item.nombre} ha sido añadido con éxito.`,
      confirmButtonText: 'Cerrar',
    });
  };
  
  // Carga los datos del producto o servicio
 const handleCarga = async () => {
    if (producto) {
        try {
            const response = await clienteAxios.get(`/marcas/${producto.marca_id}`);
            const nombreMarca = response.data.data.nombre;

            // Actualizar ambos estados
            const productoConMarca = { ...producto, tipo: 'producto', nombreMarca };
            setProducto(productoConMarca);
            setItem(productoConMarca);
        } catch (error) {
            console.error('Error al obtener la marca:', error);
        }
    } else if (servicio) {
        setItem({ ...servicio, tipo: 'servicio' });
    }
};

  
  
  useEffect(() => {
    handleCarga();
  }, [location]);
  
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true); // Inicia el estado de carga
      Swal.fire({
        title: 'Cargando...',
        text: 'Estamos cargando el producto o servicio solicitado. Por favor, espera...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Muestra el indicador de carga
        }
      });
  
      try {
        if (!producto && !servicio && codigo) {
          const response = await clienteAxios.get(`/detallePS/${codigo}`);
          const data = response.data;
  
          if (data.tipo === 'producto') {
            setItem({ ...data.data, tipo: 'producto' });
            setProducto(data.data); // Asigna el producto
          } else if (data.tipo === 'servicio') {
            setItem({ ...data.data, tipo: 'servicio' });
            setServicio(data.data); // Asigna el servicio
          } else {
            Swal.fire('Error', 'No se encontró un producto o servicio con el ID proporcionado.', 'error');
          }
        }
      } catch (error) {
        Swal.fire('Error', 'Hubo un problema al cargar los datos. Intenta nuevamente más tarde.', 'error');
      } finally {
        Swal.close(); // Cierra el SweetAlert independientemente del resultado
        setIsLoading(false); // Finaliza el estado de carga
      }
    };
  
    fetchData();
  }, [producto, servicio, codigo]);
  
  
  
  // Función para copiar la URL al portapapeles
  const copiarAlPortapapeles = () => {
    const url = window.location.href;
    navigator.clipboard.writeText(url)
      .then(() => {
        Swal.fire('¡URL copiada!', 'La URL se ha copiado al portapapeles.', 'success');
      })
      .catch(err => {
        Swal.fire('Error', 'No se pudo copiar la URL. Intenta de nuevo.', 'error');
      });
  };
  
  // Manejo del envío de la consulta
  const handleSubmitConsulta = async (e) => {
    e.preventDefault();
  
    // Validación de campos
    if (!formData.email || !formData.mensaje) {
      Swal.fire('Error', 'Por favor, completa todos los campos.', 'error');
      return;
    }
  
    setEnviando(true); // Activa el estado "Enviando" antes de hacer el envío
  
    Swal.fire({
      title: 'Enviando...',
      text: 'Estamos enviando tu consulta. Por favor espera...',
      didOpen: () => {
        Swal.showLoading(); // Muestra el cuadro de carga de SweetAlert
      }
    });
  
    try {
      const response = await clienteAxios.post('/email/enviar', {
        type: 'consultaProducto',
        data: {
          email: formData.email,
          mensaje: formData.mensaje,
          productoNombre: producto ? item.nombre : item.nombre,
        }
      });
  
      if (response.status === 200) {
        Swal.fire('Éxito', 'Consulta enviada con éxito', 'success');
        setFormData({
          email: '',
          mensaje: ''
        });
      }
    } catch (error) {
      console.error("Error en el envío:", error);
      Swal.fire('Error', 'Hubo un error al enviar la consulta. Intenta nuevamente más tarde.', 'error');
    } finally {
      setEnviando(false); // Desactiva el estado "Enviando" una vez que la solicitud termine
    }
  };
  

  return (
    <div className="w-full h-auto pt-10 pb-10 flex justify-center bg-GrisClaro">
      <div className="w-11/12 flex flex-col border-2 border-GrisOscuro rounded-xl items-center bg-Blanco">
        <div className="w-11/12 flex flex-col lg:flex-row justify-center mt-16 p-5">
          {/* Contenedor de la Imagen y Descripción */}
          <div className="w-full lg:w-8/12 flex flex-col">
            <h1 className="text-2xl font-bold mb-4 p-2 btw:p-6 lg:hidden">{item.nombre}</h1> {/* Título para mobile */}
            <div className="w-full h-48 btw:h-96 btw:p-4 flex justify-center">
              <img
                src={item.imagen}
                className="w-full bxsm:w-9/12 btw:w-9/12 h-full object-contain shadow-2xl shadow-imgshadow rounded-lg"
                alt="Producto o Servicio"
              />
            </div>
            <div className="w-full p-2">
              <h2 className="text-xl font-bold mb-2 p-2">Descripción</h2>
              <p className="p-2">{item.descripcion}</p>
            </div>
            <div className="w-full p-2">
              <h2 className="text-xl font-bold mb-2 p-2">Anexos</h2>
              {(() => {
                const anexos = [item.anexo1, item.anexo2, item.anexo3, item.anexo4, item.anexo5].filter(Boolean);
                if (anexos.length > 0) {
                  return (
                    <ul className="list-disc list-inside">
                      {anexos.map((anexo, index) => (
                        <li key={index} className="mb-2 flex">
                          <a
                            href={anexo}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-Rojo p-2 block max-w-full truncate"
                            title={anexo}
                          >
                            {anexo}
                          </a>
                        </li>
                      ))}
                    </ul>
                  );
                } else {
                  return <p className="text-gray-500 p-2">Producto sin anexos</p>;
                }
              })()}
            </div>
          </div>
  
          {/* Contenedor de Información Adicional */}
          <div className="w-full lg:w-4/12 h-full flex flex-col bg-GrisClaro rounded-lg justify-between border border-Negro mt-8 lg:mt-0">
            <h1 className="text-2xl font-bold mb-4 p-6 hidden lg:block">{item.nombre}</h1> {/* Título para desktop */}
            {producto && (
              <div className="flex justify-between mb-4 p-6 items-center">
                <label className="font-semibold text-GrisOscuro">
                  Marca:
                  <button onClick={handleRedirectMarca} className="font-bold text-Verde mx-1">
                    {item.nombreMarca}
                  </button>
                </label>
                <button onClick={copiarAlPortapapeles} className="text-Amarillo">
                  <FaShareAlt size={25} />
                </button>
              </div>
            )}
            {producto && (
              <div
                className={`w-full h-12 ${item.disponible ? "bg-Verde" : "bg-Amarillo"} text-center text-Blanco flex items-center justify-center mb-4 border-y border-Negro`}
              >
                <h2 className="font-bold text-xl">{item.disponible ? "Disponible" : "A Pedido"}</h2>
              </div>
            )}
            <div className="flex flex-col p-10 justify-center">
              <div className="flex p-2 items-end justify-center">
                <h1 className="text-xl btw:text-2xl font-bold mx-4">{item.mostrar_precio_dolar ? `US$ ${Number(item.precioventadolar).toLocaleString('es-AR')}` : `AR$ ${Number(item.precioventapeso).toLocaleString('es-AR') || Number(item.preciopeso).toLocaleString('es-AR')}`}</h1>
                {producto && <label>x Unidad</label>}
              </div>
              {producto && (
                <div className="flex p-2 items-end justify-evenly">
                  <h2 className="mb-2 text-lg font-bold">Cantidad</h2>
                  <input
                    type="number"
                    className="w-28 p-2 border text-bold"
                    value={cantidad}
                    onChange={(e) => {
                      const newCantidad = Math.max(1, parseInt(e.target.value) || 1);
                      setCantidad(newCantidad);
                    }}
                  />
                  <label className="text-GrisOscuro text-xs">{`de ${item.stock}`}</label>
                </div>
              )}
            </div>
            <div className="w-full flex flex-col gap-4 p-8 items-center">
              <button
                onClick={() => handleComprar(item)}
                className="w-3/5 h-14 text-Negro text-sm btw:text-lg bg-Blanco border border-Negro py-2 font-bold rounded-lg"
              >
                Comprar
              </button>
              <button
                onClick={() => handleAgregarAlCarrito(item)}
                className="w-3/5 h-14 text-Blanco text-sm btw:text-lg bg-Verde border border-Negro py-2 font-bold rounded-lg"
              >
                Agregar al Carrito
              </button>
            </div>
          </div>
        </div>

        {/* Formulario de consulta */}
        <div className="w-11/12 flex flex-col items-center justify-center p-5 mb-10">
  {/* Título principal */}
  <div className="w-full flex items-center mb-5">
    <h1 className="text-2xl font-bold flex-1 text-center">
      {`Consulta sobre el ${producto ? 'producto' : 'servicio'}`}
    </h1>
  </div>

  {/* Contenedor principal */}
  <div className="w-full flex flex-col-reverse lg:flex-row bg-GrisClaro rounded-lg p-8 border border-Negro">
    {/* Formulario */}
    <div className="lg:w-1/2 w-full p-4">
      <label className="block mb-2 font-bold">Mail de contacto:</label>
      <input
        type="text"
        className="w-full p-2 border border-Negro mb-4 rounded-lg"
        name="email"
        value={formData.email}
        onChange={handleChange}
      />

      <label className="block mb-2 font-bold">Mensaje:</label>
      <textarea
        className="w-full p-2 border border-Negro rounded-lg h-32 max-h-40"
        name="mensaje"
        value={formData.mensaje}
        onChange={handleChange}
      />

      <div className="flex items-center justify-center w-full mt-4">
        <button
          onClick={handleSubmitConsulta}
          disabled={enviando}
          className={`w-full h-14 ${enviando ? 'bg-Amarillo' : 'bg-Verde'} text-lg text-Blanco border border-Negro font-bold rounded-lg`}
        >
          {enviando ? 'Enviando...' : 'Enviar consulta'}
        </button>
      </div>
    </div>

    {/* Línea separadora */}
    <div className="w-full h-0.5 bg-GrisOscuro my-4 lg:hidden" /> {/* Separador horizontal */}
    <div className="hidden lg:block w-0.5 bg-GrisOscuro mx-4 max-h-full" /> {/* Separador vertical */}

    {/* Texto informativo */}
    <div className="lg:w-1/2 w-full p-4 flex flex-col justify-between">
      <div className="w-full">
        <p className="text-lg font-bold text-GrisOscuro">
          {`Envíanos tu consulta sobre el ${producto ? 'producto' : 'servicio'}`}:<br />
          -<label className="text-Rojo"> "{item.nombre}" </label>-<br />
          Te enviaremos la respuesta por el mail de contacto que nos brindes.
        </p>
      </div>
    </div>
  </div>
</div>


      </div>
    </div>
  );
}

export default DetalleProductoServicio;
